import { get } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import Helmet from "react-helmet"
import { alertTransformer } from "../utils/transformers"
import Banner from "./Banner"
import CookieConsent from "./CookieConsent"
import Footer from "./Footer"
import Header from "./Header"
import MobileMenu from "./MobileMenu"
import PageHeading from "./PageHeading"
import PageProvider from "./PageProvider"
import Ribbon from "./Ribbon"
import { updateConsent } from "../utils/consent"

const Layout = ({
  children,
  contrastLogo,
  global,
  page,
  appendHeader,
  sectionTitle,
}) => {
  const banner = get(page, "elements.banner.value[0]")
  const title = get(page, "elements.title.value")
  const alertItem = get(global, "elements.alert.value[0]")
  const enableAlert =
    get(global, "elements.enable_alert.value[0].codename") === "yes"
  const cookieConsentText = get(global, "elements.cookie_consent_text.value")
  const cookieConsentTextLinks = get(
    global,
    "elements.cookie_consent_text.links"
  )
  const cookieConsentButtonLabel = get(
    global,
    "elements.cookie_consent_button_label.value"
  )
  const isHome = get(page, "system.codename") === "homepage"

  return (
    <PageProvider>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,400i,400b,700,900&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      {isHome && alertItem && enableAlert ? (
        <Ribbon {...alertTransformer(alertItem)} />
      ) : null}
      <Header
        contrastLogo={contrastLogo}
        global={global}
        append={appendHeader}
      />
      {banner ? <Banner banner={banner} /> : null}
      <div>
        <main>
          {title ? (
            <PageHeading
              heading={title}
              headingLevel={isHome ? "2" : "1"}
              sectionTitle={sectionTitle}
            />
          ) : null}
          {children}
        </main>
      </div>
      <Footer global={global} />
      <CookieConsent
        text={cookieConsentText}
        textLinks={cookieConsentTextLinks}
        buttonLabel={cookieConsentButtonLabel}
        onAccept={updateConsent}
      />
      <MobileMenu global={global} />
    </PageProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  global: PropTypes.object.isRequired,
}

export default Layout
